import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useModalState } from 'hooks/useModalState/useModalState';
import { logoutUser } from 'api/auth/auth';

import { LogoutUser } from './LogoutUser';
import { LogoutUserContainerProps } from './LogoutUser.types';

export const LogoutUserContainer = ({ selectedUser, setSelectedUser }: LogoutUserContainerProps) => {
  const { formatMessage } = useLocale();
  const queryClient = useQueryClient();
  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onLogoutUser, isLoading } = useMutation(logoutUser, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeyEnum.USERS]);

      toast.dark(formatMessage({ id: AppMessages['user.logout.success'] }));
      onModalClose();
    },
  });

  const onSubmit = () => {
    onLogoutUser(selectedUser.id);
  };

  return (
    <LogoutUser
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
